import React from "react";
import {
  FaCog,
  FaMapMarkedAlt,
  FaPlus,
  FaThLarge,
} from "react-icons/fa";

import KataButton from "../ui/KataButton";

export default function KataToolbar({
  total,
  viewMode,
  onViewModeChange,
  onCreate,
  onManage,
}) {
  return (
    <div className="flex flex-col gap-4 rounded-3xl border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-white/5 sm:p-5 lg:flex-row lg:items-center lg:justify-between">
      <div>
        <p className="text-lg font-semibold text-slate-950 dark:text-white">
          {total} annonce{total > 1 ? "s" : ""} disponible
          {total > 1 ? "s" : ""}
        </p>

        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          Trouvez un judoka correspondant à votre recherche.
        </p>
      </div>

      <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
        <div className="flex rounded-2xl border border-slate-200 bg-slate-50 p-1 dark:border-white/10 dark:bg-slate-950">
          <button
            type="button"
            onClick={() => onViewModeChange("cards")}
            className={[
              "flex min-h-10 flex-1 items-center justify-center gap-2 rounded-xl px-4 text-sm font-semibold transition sm:flex-none",
              viewMode === "cards"
                ? "bg-white text-orange-600 shadow-sm dark:bg-white/10 dark:text-orange-300"
                : "text-slate-500 hover:text-slate-950 dark:text-slate-400 dark:hover:text-white",
            ].join(" ")}
          >
            <FaThLarge />
            Annonces
          </button>

          <button
            type="button"
            onClick={() => onViewModeChange("map")}
            className={[
              "flex min-h-10 flex-1 items-center justify-center gap-2 rounded-xl px-4 text-sm font-semibold transition sm:flex-none",
              viewMode === "map"
                ? "bg-white text-orange-600 shadow-sm dark:bg-white/10 dark:text-orange-300"
                : "text-slate-500 hover:text-slate-950 dark:text-slate-400 dark:hover:text-white",
            ].join(" ")}
          >
            <FaMapMarkedAlt />
            Carte
          </button>
        </div>

        <KataButton
          icon={FaCog}
          variant="secondary"
          onClick={onManage}
          className="w-full sm:w-auto"
        >
          Gérer mon annonce
        </KataButton>

        <KataButton
          icon={FaPlus}
          onClick={onCreate}
          className="w-full sm:w-auto"
        >
          Déposer une annonce
        </KataButton>
      </div>
    </div>
  );
}